@reference "../../styles/ui.css";

nav.pages {
  @apply inline-flex items-center justify-center md:justify-end shrink-0 ms-0 md:ms-3 mt-3 md:mt-0;
}

nav.pages .buttons {
  @apply inline-flex rounded-md relative shadow-sm z-0 -space-x-px;
}

nav.pages button {
  @apply bg-white border border-gray-300 font-medium px-3 py-2 text-gray-500 text-sm focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors;
}

nav.pages button:not(.active):not(:disabled):hover {
  @apply bg-gray-100 text-gray-700;
}

nav.pages button:not(.active):not(:disabled):active {
  @apply bg-blue-100 border-blue-500 text-blue-600;
}

nav.pages button.active {
  @apply bg-blue-100 text-blue-600;
}

nav.pages button:disabled {
  @apply cursor-not-allowed;
}

nav.pages :first-child {
  @apply rounded-l-md;
}

nav.pages :last-child {
  @apply rounded-r-md;
}
